import { Login as SharedLogin } from "@valenzinsights/shared-pages";

import { useMsal } from "@azure/msal-react";

export function Login() {
	const { instance } = useMsal();
	return <SharedLogin instance={instance} />;
}
